import { createContext, useContext } from 'react'

import { SelectedSort } from './NotificationSortContextProvider'

type NotificationSortState = {
  sort: SelectedSort
  setSort: (newSort: SelectedSort) => void
}

export const NotificationSortContext = createContext<NotificationSortState | null>(null)

export const useNotificationSortContext = () => {
  const context = useContext(NotificationSortContext)
  if (!context) throw new Error('useNotificationSortContext must be used within a NotificationSortContext')
  return context
}
